module.exports = __webpack_public_path__ + "static/media/check.a030765f.svg";